import { Box } from "@material-ui/core";
import React, { useContext } from "react";
import { MedicoTerceiroContext } from "../../../../context/MedicoTerceiroContext";
import FormBase from "../../../../forms/FormBase";
import Steps from "../../../../components/steps/Steps";
import AbsenceConflictDeclaration from "../../../components/materialui/MedicoTerceiro/termsDeclarations/AbsenceConflictDeclaration";
import SupplierDeclaration from "../../../components/materialui/TermsDeclarations/SupplierDeclaration";
import RefusalPresentVaccineTerm from "../../../components/materialui/TermsDeclarations/RefusalPresentVaccineTerm";
import ImmunityDeclaration from "../../../components/materialui/TermsDeclarations/ImmunityDeclaration";
import ClinicalStaffDeclaration from "../../../components/materialui/MedicoTerceiro/termsDeclarations/ClinicalStaffDeclaration";
import { SupplierDeclarationItem } from "../../../../forms/shared/termsDeclarations/SupplierDeclarationForm";
import { RefusalPresentVaccineItem } from "../../../../forms/shared/termsDeclarations/RefusalPresentVaccineForm";


export default function TermsDeclarationsStep() {

    const { state, dispatch } = useContext(MedicoTerceiroContext);

    const onInputChange = (name: string, form: FormBase, value: any) => {
        dispatch({
            type: "UPDATE_FORM",
            payload: { form, value, name },
        });
    };

    const onCrudSupplierAction = (subTypeParam: "InsertOrUpdate" | 'Delete' | 'Cancel' | 'Edit', supplierDeclarationItem?: SupplierDeclarationItem) => {
        dispatch({
            type: "CRUD_FORM_SUPPLIER_DECLARATION",
            payload: { subType: subTypeParam, item: supplierDeclarationItem },
        });
    };

    const onInputRefusalPresentVaccineItemChange = (name: string, form: FormBase, value: any, item: RefusalPresentVaccineItem) => {
        dispatch({
            type: "UPDATE_FORM_REFUSAL_PRESENT_VACCINE_ITEM",
            payload: { form, value, name, item },
        });
    };

    return (
        <div>
            <Steps.StepTitle text="Termos e Declarações" />

            <Box mt={2}>
                <AbsenceConflictDeclaration
                    TermsDeclarationsForm={state.TermsDeclarationsForm}
                    Name={state.PersonalDataForm.Name.Value}
                    Crm={state.PersonalDataForm.CRM.Value}
                    onInputChange={onInputChange} />

            </Box>


            <Box mt={2}>
                <SupplierDeclaration
                    SupplierDeclarationForm={state.SupplierDeclarationForm}
                    onCancelEditSupplierItem={() => { onCrudSupplierAction("Cancel") }}
                    onInserOrUpdateSupplierItem={() => { onCrudSupplierAction("InsertOrUpdate") }}
                    onEditSupplierClick={(e: SupplierDeclarationItem) => { onCrudSupplierAction("Edit", e) }}
                    onDeleteSupplierClick={(e: SupplierDeclarationItem) => { onCrudSupplierAction("Delete", e) }}
                    onCheckedClick={(e: boolean) => { onInputChange("SupplierDeclaration", state.TermsDeclarationsForm, e) }}
                    Name={state.PersonalDataForm.Name.Value}
                    Checked={state.TermsDeclarationsForm.SupplierDeclaration.Value.Checked}
                    Crm={state.PersonalDataForm.CRM.Value}
                    onInputChange={onInputChange} />

            </Box>

            <Box mt={2}>
                <RefusalPresentVaccineTerm
                    Name={state.PersonalDataForm.Name.Value}
                    onInputChange={onInputChange}
                    Checked={state.TermsDeclarationsForm.RefusalPresentVaccineTerm.Value.Checked}
                    onCheckedClick={(e: boolean) => { onInputChange("RefusalPresentVaccineTerm", state.TermsDeclarationsForm, e) }}
                    onInputRefusalPresentVaccineItemChange={onInputRefusalPresentVaccineItemChange}
                    RefusalPresentVaccineForm={state.RefusalPresentVaccineForm}
                />

            </Box>

            <Box mt={2}>
                <ImmunityDeclaration
                    Checked={state.TermsDeclarationsForm.ImmunityDeclaration.Value.Checked}
                    onCheckedClick={(e: boolean) => { onInputChange("ImmunityDeclaration", state.TermsDeclarationsForm, e) }}
                    Name={state.PersonalDataForm.Name.Value}
                    onInputChange={onInputChange} />

            </Box>

            <Box mt={2}>
                <ClinicalStaffDeclaration
                    TermsDeclarationsForm={state.TermsDeclarationsForm}
                    onInputChange={onInputChange} />

            </Box>

        </div>
    );
}